import React from 'react';
import { AuthProvider } from '../contexts/AuthContext';
import { NotificationProvider } from '../contexts/NotificationContext';
import { BonusProvider } from '../contexts/BonusContext';
import { WebSocketProvider } from '../contexts/WebSocketContext';

interface AppProvidersProps {
  children: React.ReactNode;
}

export function AppProviders({ children }: AppProvidersProps) {
  return (
    <AuthProvider>
      <NotificationProvider>
        <WebSocketProvider>
          <BonusProvider>
            {children}
          </BonusProvider>
        </WebSocketProvider>
      </NotificationProvider>
    </AuthProvider>
  );
}